export function encode(raw: any) {
    return btoa(JSON.stringify(raw));
}

export function decode(encoded: string) {
    return JSON.parse(atob(encoded));
}